import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

/** Manual "sync now" for the signed-in user's mailbox. */
export const syncMyEmail = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((i) => z.object({ days: z.number().int().min(1).max(30).optional() }).parse(i ?? {}))
  .handler(async ({ context, data }) => {
    const { runEmailSync, recordEmailSyncRun, hasMailConnected } = await import("./email-sync.server");
    if (!(await hasMailConnected(context.userId))) {
      throw new Error("Gmail isn't connected for this account yet.");
    }
    const startedAt = new Date().toISOString();
    try {
      const result = await runEmailSync(context.supabase, context.userId, { days: data.days });
      await recordEmailSyncRun(context.supabase, context.userId, "manual", startedAt, result);
      return result;
    } catch (e: any) {
      await recordEmailSyncRun(
        context.supabase,
        context.userId,
        "manual",
        startedAt,
        null,
        String(e?.message ?? e),
      );
      throw e;
    }
  });

/** Last time we read the mailbox, for the Settings row. */
export const getEmailSyncState = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { data } = await context.supabase
      .from("email_sync_state")
      .select("last_synced_at, last_error")
      .eq("user_id", context.userId)
      .maybeSingle();
    return {
      lastSyncedAt: (data as any)?.last_synced_at ?? null,
      lastError: (data as any)?.last_error ?? null,
    };
  });
